import { ReactNode } from 'react'
import renderDatetime from '../../../../../../helpers/tables/render-datetime'
import { ColumnType } from 'antd/es/table'
import ReceiptPosition from '../../../../../../types/api/receipt-position'
import EditAmount from '../components/edit-amount/edit-amount'
import formatNumber from '../../../../../../helpers/formatters/format-any-number'

type ReceiptColumn = ColumnType<ReceiptPosition> & {
    editable?: boolean
    FormItem?: ReactNode
    children?: ReceiptColumn[]
}

export const columns: ReceiptColumn[] = [
    {
        title: 'Номер заказа',
        dataIndex: ['receipt', 'id'],
        minWidth: 50,
    },
    {
        title: 'Поставщик',
        dataIndex: ['receipt', 'supplier', 'name'],
        minWidth: 100,
    },
    {
        title: 'Статус',
        dataIndex: ['receipt', 'receiptStatus'],
        minWidth: 50,
    },
    {
        title: 'Дата заказа',
        dataIndex: ['receipt', 'createdAt'],
        minWidth: 50,
        render: (v: string) => {
            return v ? renderDatetime(v) : undefined
        },
    },
    {
        title: 'Дата прихода',
        dataIndex: ['receipt', 'estimatedDate'],
        minWidth: 50,
        render: (v: string) => {
            return v ? renderDatetime(v) : undefined
        },
    },
    {
        title: 'Позиция заказа',
        children: [
            { title: 'Тип материала', dataIndex: ['material', 'material_type', 'name'] },
            {
                title: 'Ширина',
                dataIndex: ['material', 'width'],
                width: 70,
                render(value) {
                    return formatNumber(Number(value ?? 0))
                },
            },
            {
                title: 'Кол-во',
                dataIndex: 'amount',
                minWidth: 50,
                render: (value, record) => {
                    const unitName = record.unit ? record.unit.shortName : ''
                    return `${formatNumber(value)} ${unitName}`
                },
                editable: true,
                FormItem: <EditAmount />,
            },
            {
                title: 'Ининциатор',
                dataIndex: ['initiator', 'username'],
                minWidth: 150,
            },
        ],
    },
]
